import styled from 'styled-components';

import { manageColor } from '@pb/styles';
import { TStyledSvgProperties } from './svg.types';

export const StyledSvg = styled.svg<TStyledSvgProperties>`
    fill: ${({ fillColor, theme }) => manageColor({ color: fillColor, theme })};
`;
